import { createStore } from 'vuex';
import esriRequest from '@arcgis/core/request';

export default createStore({
  state: {
    data: {
      // data retrieved from web services
      supportingLayers: '', //used to create the supportinglayer tree
      slReady: '',
    },
    config: {
      // config info
      supportingMapLayers: [
        {
          featureService: '',
          skipLayers: [],
          title: 'Sedimentation Layers',
          popupTemplate: [],
          webmap:
            'https://www.arcgis.com/sharing/rest/content/items/7025813561744c31bed30806b0e6a963/data?f=json',
        },
        {
          featureService: '',
          skipLayers: [],
          title: 'Aquifers Layers',
          popupTemplate: [],
          webmap:
            'https://www.arcgis.com/sharing/rest/content/items/7d1c55fe2a78436da26377d1cc6da4c4/data?f=json',
        },
      ],

      supportingLayersTitle: 'Additional Layers',
      supportingLayersOnMap: false,
      supportingLayersInPanel: true,
      panelDisplayType: 'tabsVertical', //plain, tabsHorizontal, tabsVertical
      appDisplayType: 'webMap', //storyMap, webMap
      condensedTabs: false,
      containerWidth: '',
      currentWebMap: 'about',
      saveWebmapExtent: '',
    },
    // app state info -- supporting layers
    tree: {
      ticked: [],
      expanded: [999, 1000],
      tickedObj: [],
    },
    selectedLayerList: [],
    supportingVisibleLayerOpacity: {},

    // app state info -- layout
    showControls: false,
    hideControls: true,
    mapPrintURI: '',
    resetZoomRequest: false,
  },
  mutations: {
    //data retrieved from web services
    updateSupportingLayers(state, obj) {
      state.data.supportingLayers = obj;
    },
    updateSLReady(state, bool) {
      state.data.slReady = bool;
    },
    updateSupportingSublayerList(state, obj) {
      state.data.supportingSublayerList = obj;
    },

    //app state -- supporting layers
    updateTreeState(state, obj) {
      state.tree.ticked = obj.ticked;
      state.tree.expanded = obj.expanded;
      state.tree.tickedObj = obj.tickedObj;
    },
    updateSupportingLayerVisibleOpacity(state, obj) {
      state.supportingVisibleLayerOpacity = obj;
    },
    updateMapPrintURI(state, uri) {
      state.mapPrintURI = uri;
    },
    updateCondensedTabs(state, bool) {
      state.condensedTabs = bool;
    },
    updateContainerWidth(state, val) {
      state.containerWidth = val;
    },

    updateCurrentWebMap(state, string) {
      state.currentWebMap = string;
    },
    updateSaveWebmapExtent(state, string) {
      state.saveWebmapExtent = string;
    },
    updateResetZoomRequest(state) {
      state.resetZoomRequest = !state.resetZoomRequest;
    },
  },

  actions: {
    requestSupportingLayers(context) {
      console.log('request supporing layers');
      //for each map service object in supporting map layers
      try {
        let obj = [];
        let smnum = context.state.config.supportingMapLayers.length;
        let services = context.state.config.supportingMapLayers;

        for (let i = 0; i < smnum; i++) {
          esriRequest(services[i].webmap, {
            responseType: 'json',
          }).then(function(response) {
            //let layerJson = response.data.operationalLayers;
            //push main header to the object

            obj.push({
              title: services[i].title,
              layers: response.data.operationalLayers,
              id: 999 + i,
              noTick: true,
              type: 'header',
              layerType: 'GroupLayer',
            });
            let param = { obj: obj[i], index: i };
            context.dispatch('parseData', param).then(function(response) {
              if (response == 1) {
                context.commit('updateSupportingLayers', obj);
                context.commit('updateSLReady', true);
              }
            });
          });
        }
        // context.state.config.supportingMapLayers.forEach(
        //  (service, index) => {}
        // );
      } catch (error) {
        context.commit('updateSupportingLayers', 'error');
      }
    },
    parseData(context, param) {
      console.log('Parse data called');
      if (!param.obj) {
        setTimeout(function() {
          console.log('waited three seconds');
          context.dispatch('requestSupportingLayers', param);
        }, 3000);
        return 'error';
      }

      let obj = param.obj;

      if (obj.name) {
        if (obj.name == 'Yellow River Watershed') {
          console.log(obj);
        }
      }
      let msi = param.index;
      if (!obj) {
        setTimeout(function() {
          console.log('waited three seconds');
          context.dispatch('requestSupportingLayers', param);
        }, 3000);
        return 'error';
      }
      if (obj.layerType !== 'GroupLayer' || !obj.layers) {
        obj.body = 'toggle';
        //console.log(msi);
        obj.webMapIndex = msi;

        esriRequest(obj.url + '?f=json', {
          responseType: 'json',
        }).then(function(response) {
          if (response.data.description) {
            obj.description = response.data.description;
          } else {
            obj.description = '';
          }
          if (response.data.geometryType) {
            console.log(response.data);
            if (response.data.geometryType == 'esriGeometryPolygon') {
              obj.showOpacitySlider = true;
            }
          }

          if (obj.layerType == 'ArcGISTiledMapServiceLayer') {
            obj.showOpacitySlider = true;
          }
        });
      }
      //this function recursively reverses the order of all the lists, otherwise everything comes in backwards
      if (obj.layers) {
        obj.layers.reverse();

        if (obj.layerType == 'GroupLayer' || obj.layers) {
          obj.noTick = true;
        }

        for (let i = 0; i < obj.layers.length; i++) {
          let param = {
            obj: obj.layers[i],
            index: msi,
          };
          context.dispatch('parseData', param); // loop through items inside folder
        }
      }
      return param.index;
    },
    requestSupportingLayersMapService(context) {
      //for each map service object in supporting map layers
      try {
        let obj = [];
        let smnum = context.state.config.supportingMapLayers.length;
        let smcount = 1;
        context.state.config.supportingMapLayers.forEach((service, index) => {
          esriRequest(service.mapService + '/layers?f=pjson', {
            responseType: 'json',
          }).then(function(response) {
            let layerJson = response.data.layers;
            //push main header to the object
            obj.push({
              label: service.title,
              children: [],
              id: 999 + index,
              noTick: true,
              type: 'header',
            });
            let storeNodes = [];
            let type = '';
            layerJson.forEach((l) => {
              service.popupTemplate.forEach((popup) => {
                if (l.id == popup.id) {
                  type = 'Featue Layer';
                } else type = 'Raster Layer';
              });
              // add layer to layer viewer if it's id is not present in the skip array
              if (service.skipLayers.indexOf(l.id) == -1) {
                // Group Layer with no parent
                if (l.type == 'Group Layer' && !l.parentLayer) {
                  //push the object to the list as child of main header
                  obj[index].children.push({
                    label: l.name,
                    children: [],
                    id: l.id + '_' + index,
                    noTick: true,
                    type: type,
                  });
                  //find the index of the object we just pushed, saves the reference to the location
                  let parentIndex = obj[index].children.findIndex(
                    (obj) => obj.id == l.id + '_' + index
                  );
                  //save the parent node to the store with reference to its location in the object
                  storeNodes.push({
                    parentIndex: parentIndex,
                    parentLoc: obj[index].children[parentIndex],
                    parentId: l.id + '_' + index,
                    description: l.description,
                  });
                }
                // featurel layer with parent
                if (l.type !== 'Group Layer' && l.parentLayer) {
                  //find the location of the parent in the node lookup
                  let nodesIndex = storeNodes.findIndex(
                    (obj) => obj.parentId == l.parentLayer.id + '_' + index
                  );
                  //set the location of the parent
                  let parentLoc = storeNodes[nodesIndex].parentLoc;
                  //push the child to the parent
                  parentLoc.children.push({
                    label: l.name,
                    children: [],
                    body: 'toggle',
                    id: l.id + '_' + index,
                    description: l.description,
                    type: type,
                  });
                }
                // group layer with parent
                if (l.type == 'Group Layer' && l.parentLayer) {
                  //find the location of the parent in the node lookup
                  let nodesIndex = storeNodes.findIndex(
                    (obj) => obj.parentId == l.parentLayer.id + '_' + index
                  );
                  //set the location of the parent
                  let parentLoc = storeNodes[nodesIndex].parentLoc;
                  //push the new parent into the found parent as child
                  parentLoc.children.push({
                    label: l.name,
                    children: [],
                    id: l.id + '_' + index,
                    noTick: true,
                    type: type,
                  });
                  //find the index of the child we just pushed
                  let parentIndex = parentLoc.children.findIndex(
                    (obj) => obj.id == l.id + '_' + index
                  );
                  //save the reference to the location
                  parentLoc = parentLoc.children[parentIndex];
                  //save the parent node to the store with reference to its location in the object
                  storeNodes.push({
                    parentIndex: parentIndex,
                    parentLoc: parentLoc,
                    parentId: l.id + '_' + index,
                    description: l.description,
                  });
                }
                // feature layer with no parent length = number of nodes
                if (l.type !== 'Group Layer' && !l.parentLayer) {
                  obj[index].children.push({
                    label: l.name,
                    children: [],
                    body: 'toggle',
                    id: l.id + '_' + index,
                    description: l.description,
                    type: type,
                  });
                }
              }
            });
            smcount = smcount + 1;

            if (smcount == smnum) {
              context.commit('updateSupportingLayers', obj);
              context.commit('updateSLReady', true);
            }
          });
        });
      } catch (error) {
        context.commit('updateSupportingLayers', 'error');
      }
    },
  },

  modules: {},
});
